<template>
  <!--Make responsive to membership types table-->
  <v-card
    :class="'mx-auto align-self-stretch' + cardClass"
    min-width="15vw"
    max-width="344"
    v-bind="props"
  >
    <v-img
      v-if="membershipType.programIdTargetIds?.programId == 1"
      src="/public-portal/images/AP2.jpg"
      height="20%"
      cover
    ></v-img>
    <v-img
      v-else="membershipType.programIdTargetIds?.programId == 2"
      src="/public-portal/images/IIT2.jpg"
      height="20%"
      cover
    ></v-img>
    <v-card-subtitle class="mt-2 pt-0 pb-0">
      <h4
        v-if="membershipType.programIdTargetIds?.programId == 1"
        style="color: red"
      >
        Adult Program
      </h4>
      <h4
        v-else-if="membershipType.programIdTargetIds?.programId == 2"
        style="color: limegreen"
      >
        Youth Program
      </h4>
      <h4
        v-else-if="membershipType.programIdTargetIds?.programId == 3"
        style="color: blue"
      >
        Universal Access Program
      </h4>
    </v-card-subtitle>
    <v-card-title class="ma-0 pt-0 pb-0">
      {{ membershipName }}
    </v-card-title>

    <v-card-text>
      <div>
        <h1
          v-if="membershipType.expirationType == 'Never Expires'"
          class="text-h1"
        >
          ${{ membershipPrice }}
        </h1>
        <h1
          v-else-if="membershipType.expirationType == 'Fixed Date'"
          class="text-h1"
        >
          ${{ membershipPrice }} /Season
        </h1>
        <!--TODO Add season dates to this-->
        <h1 v-else class="text-h1">
          ${{ membershipPrice }} /{{ membershipExpirationType }}
        </h1>
        <!--TODO Change to use catalog price-->
      </div>
      <!--<div>
        <h3 v-if="membershipRenewalEligible == true">
          Renews at ${{ membershipRenewalPrice }}
        </h3>
        <h3 v-else-if="membershipType.id == 4">Renews as monthly membership</h3>
        <br v-else-if="membershipType.id == 9" />
        <br v-else />
      </div>-->
      <!--<p>
        Description text -- need to add description field to table definition
      </p>-->
      <v-list v-if="membershipType.membershipTypeId == 882">
        <v-list-item>
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Unlimited use of Paddle fleet
        </v-list-item>
        <v-list-item>
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Eligible for
          <v-tooltip
            text="Guest Privileges is a one time add on fee which allows you to bring as many guests as will fit into your boat with you. Guest privileges also allow you to rent additional Kayaks and Stand Up Paddleboards at a discount for your guests. You must be present to take advantage of your membership's guest privleges."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">guest privileges</u>
            </template>
          </v-tooltip>
        </v-list-item>
      </v-list>
      <v-list v-else-if="membershipType.programIdTargetIds?.programId == 1">
        <v-list-item v-if="membershipType.membershipTypeId == 4">
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Unlimited use of Mercury and Paddle fleet
        </v-list-item>
        <v-list-item v-else>
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Unlimited use of all fleets
        </v-list-item>
        <!--Guest Privileges-->
        <v-list-item v-if="membershipGuestEligible == true">
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Eligible for
          <v-tooltip
            text="Guest Privileges is a one time add on fee which allows you to bring as many guests as will fit into your boat with you. Guest privileges also allow you to rent additional Kayaks and Stand Up Paddleboards at a discount for your guests. You must be present to take advantage of your membership's guest privleges."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">guest privileges</u>
            </template>
          </v-tooltip>
        </v-list-item>
        <v-list-item v-else>
          <template v-slot:prepend>
            <v-icon color="red" icon="mdi-close"></v-icon>
          </template>
          Not eligible for
          <v-tooltip
            text="Guest privileges is a one time add on fee which allows you to bring as many guests as will fit into your boat with you. Guest privileges also allow you to rent additional Kayaks and Stand Up Paddleboards at a discount for your guests. You must be present to take advantage of your membership's guest privleges."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">guest privileges</u>
            </template>
          </v-tooltip>
        </v-list-item>
        <!--Beginner Class Access-->
        <v-list-item v-if="membershipClassesEligible">
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Access to
          <v-tooltip
            text="Complimentary access to beginner level classes, learn to sail! The beginner level classes are designed to convey the foundational concepts of sailing, allowing you to get on the water to understand these concepts practically and prepare you for intermediate level learning."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">beginner classes</u>
            </template>
          </v-tooltip>
        </v-list-item>
        <v-list-item v-else>
          <template v-slot:prepend>
            <v-icon color="red" icon="mdi-close"></v-icon>
          </template>
          No
          <v-tooltip
            text="The beginner level classes are designed to convey the foundational concepts of sailing, allowing you to get on the water to understand these concepts practically and prepare you for intermediate level learning."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">beginner class</u>
            </template>
          </v-tooltip>
          access
        </v-list-item>
        <!--Intermediate Class Access-->
        <v-list-item v-if="membershipIntermediateAccess">
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Access to
          <v-tooltip
            text="Complimentary access to intermediate level classes. The intermediate level classes are designed to build upon the basics from the beginner level and begin to hone your sailing skills. Cirriculum touches on how to sail faster, use additional sailpower, and fine tune maneuvering."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">intermediate classes</u>
            </template>
          </v-tooltip>
        </v-list-item>
        <v-list-item v-else>
          <template v-slot:prepend>
            <v-icon color="red" icon="mdi-close"></v-icon>
          </template>
          No
          <v-tooltip
            text="The intermediate level classes are designed to build upon the basics from the beginner level and begin to hone your sailing skills. Cirriculum touches on how to sail faster, use additional sailpower, and fine tune maneuvering."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">intermediate class</u>
            </template>
          </v-tooltip>
          access
        </v-list-item>
        <!--Advanced Class Access-->
        <v-list-item v-if="membershipAdvancedAccess">
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Access to paid
          <v-tooltip
            text="Access to paid advanced level classes. The advanced classes are your opportunity to branch out into new, faster, and more powerful boats. You will apply all the prior learning from the beginner and intermediate level classes into new equipent and techniques."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">advanced classes</u>
            </template>
          </v-tooltip>
        </v-list-item>
        <v-list-item v-else>
          <template v-slot:prepend>
            <v-icon color="red" icon="mdi-close"></v-icon>
          </template>
          No
          <v-tooltip
            text="The advanced classes are your opportunity to branch out into new, faster, and more powerful boats. You will apply all the prior learning from the beginner and intermediate level classes into new equipent and techniques."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">advanced class</u>
            </template>
          </v-tooltip>
          access
        </v-list-item>

        <!--Discount event tickets TODO need to add a field to the table definition for this-->
        <v-list-item v-if="membershipEventAccess">
          <template v-slot:prepend>
            <v-icon color="green" icon="mdi-check"></v-icon>
          </template>
          Discounts to
          <v-tooltip
            text="CBI hosts several social events throughout the season including dock parties and regattas."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">Events</u>
            </template>
          </v-tooltip>
          and
          <v-tooltip
            width="400"
            text="The only public reserved seating event to watch the Boston Pops Fireworks Spectacular on the Charles River! Avoid the commotion of the masses on the Esplanade, yet preserve the spirit of camaraderie and the sounds and sights of the Boston Pops Fireworks Spectacular as you enter our gates."
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">July 4th</u>
            </template>
          </v-tooltip>
        </v-list-item>
        <v-list-item v-else>
          <template v-slot:prepend>
            <v-icon color="red" icon="mdi-close"></v-icon>
          </template>
          No discounts to
          <v-tooltip
            text="CBI hosts several social events throughout the season including dock parties and regattas."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">Events</u>
            </template>
          </v-tooltip>
          and
          <v-tooltip
            text="The only public reserved seating event to watch the Boston Pops Fireworks Spectacular on the Charles River! Avoid the commotion of the masses on the Esplanade, yet preserve the spirit of camaraderie and the sounds and sights of the Boston Pops Fireworks Spectacular as you enter our gates."
            width="400"
          >
            <template v-slot:activator="{ props }">
              <u v-bind="props" class="link">July 4th</u>
            </template>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions class="align-end sticky-actions mb-3" v-if="!isAdded">
      <v-spacer></v-spacer>
      <v-btn
        prepend-icon="mdi-shopping"
        variant="outlined"
        :loading="memberOrder?.busy.value"
        :disabled="!memberOrder?.canEdit.value"
        @click="addMembership(false)"
        >{{ addToCartText }}</v-btn
      >
      <v-btn
        prepend-icon="mdi-shopping"
        color="primary"
        :loading="memberOrder?.busy.value"
        :disabled="!memberOrder?.canEdit.value"
        @click="addMembership(true)"
        >Purchase Now</v-btn
      >
    </v-card-actions>
    <v-card-actions
      class="align-end sticky-actions mb-3 d-flex flex-column"
      v-else
    >
      <v-btn
        prepend-icon="mdi-delete"
        class="mb-2"
        variant="outlined"
        :loading="memberOrder?.busy.value"
        :disabled="!memberOrder?.isOpen.value"
        @click="removeMembership()"
      >
        Remove from Cart
      </v-btn>

      <v-btn
        v-if="membershipGuestEligible && !hasGP"
        prepend-icon="mdi-shopping"
        variant="outlined"
        :loading="memberOrder?.busy.value"
        :disabled="!memberOrder?.isOpen.value"
        @click="addGuestPrivs(false)"
      >
        Purchase Guest Privileges
      </v-btn>
      <v-btn
        v-else
        prepend-icon="mdi-delete"
        variant="outlined"
        :loading="memberOrder?.busy.value"
        :disabled="!memberOrder?.isOpen.value"
        @click="removeGuestPrivs()"
      >
        Remove Guest Privileges
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts" setup>
import { MembershipType } from "@/api/models/MembershipType";
import type { MembershipTypeMember } from "../../../cbi-generator/generated/dto/MembershipTypeMember";
import { ProductListing } from "@/api/models/shop/ProductListing";
import { useCatalog } from "@/composables/shop/useCatalog";
import type { AddToCart } from "../../../cbi-generator/generated/dto/AddToCart";
import type { LineItemMember } from "../../../cbi-generator/generated/dto/LineItemMember";
import { buildMemberCatalogPurchase } from "@/composables/shop/memberCatalogPurchase";
import {
  memberOrderSessionKey,
  type MemberOrderSession,
} from "@/composables/shop/useMemberOrder";
import { useNotificationStore } from "@/stores/notification";
import { useUser } from "@/composables/useUser";
import { useMemberPersonId } from "@/composables/people/useMemberPersonId";
const userStore = useUser();
const memberPersonId = useMemberPersonId();
const props = defineProps<{
  membershipType: MembershipTypeMember;
  person?: { personId: number };
  requirePerson?: boolean;
}>();
const router = useRouter();
const memberOrder = inject<MemberOrderSession | null>(
  memberOrderSessionKey,
  null,
);
const notification = useNotificationStore();
const membershipName = computed(
  () =>
    props.membershipType.membershipTypeDisplayName ||
    props.membershipType.membershipTypeName,
);
const membershipPrice = ref("Loading...");
const membershipExpirationType = computed(() =>
  props.membershipType.expirationType == "Interval"
    ? "Monthly"
    : props.membershipType.expirationType,
);
const membershipDuration = computed(() => props.membershipType.duration); //TODO fix this for new subscription model
const membershipRenewalEligible = computed(
  () => props.membershipType.renewalEligible === "Y",
);
const membershipRenewalDiscount = computed(
  () => props.membershipType.renewalEligible === "Y",
);
const membershipRenewalPrice = computed(() => props.membershipType.price); //TODO public discount mapping for renewal

const membershipGuestEligible = computed(
  () => props.membershipType.canHaveGuestPrivs === "Y",
);
const membershipLimitedAccess = computed(
  () => props.membershipType.ratingsRestricted === "Y",
);

const membershipClassesEligible = computed(
  () => props.membershipType.membershipTypeId != 882,
);

const membershipIntermediateAccess = computed(
  () =>
    props.membershipType.membershipTypeId == 1 ||
    props.membershipType.membershipTypeId == 881 ||
    props.membershipType.membershipTypeId == 9,
);

const membershipAdvancedAccess = computed(
  () =>
    props.membershipType.membershipTypeId == 1 ||
    props.membershipType.membershipTypeId == 881 ||
    props.membershipType.membershipTypeId == 9,
);

const membershipEventAccess = computed(
  () =>
    props.membershipType.membershipTypeId == 1 ||
    props.membershipType.membershipTypeId == 9,
);

const membershipProduct = ref<ProductListing | null>(null);
const guestPrivsProduct = ref<ProductListing | null>(null);
const existingCartMembership = computed(() =>
  findLine(membershipProduct.value),
);
const existingCartGP = computed(() =>
  findLine(guestPrivsProduct.value, existingCartMembership.value?.childItems),
);
const hasGP = computed(() => !!existingCartGP.value);

const addToCartText = computed(() =>
  existingCartMembership.value ? "Update Cart" : "Add to Cart",
);

const isAdded = computed(() => !!existingCartMembership.value);

const cardClass = computed(() =>
  isAdded.value ? " border-md border-opacity-75" : "",
);

function findLine(
  item: ProductListing | null,
  lines: LineItemMember[] | null = memberOrder?.order.value?.lineItems ?? [],
): LineItemMember | undefined {
  if (!item) return undefined;
  const instanceId = item.catalogItemInstance.assignId;
  for (const line of lines ?? []) {
    if (line.itemInstanceIdTargetIds.assignId === instanceId) return line;
    const child = findLine(item, line.childItems ?? []);
    if (child) return child;
  }
  return undefined;
}

function personRef() {
  const personId =
    props.person?.personId ??
    userStore.currentPersonRef.value?.personId ??
    memberPersonId.value;
  return personId != null && personId > 0 ? { personId } : null;
}

async function removeMembership() {
  const line = existingCartMembership.value;
  if (!memberOrder || !line) return;
  try {
    await memberOrder.remove({ assignId: line.assignId });
  } catch (error) {
    notification.addSnackbar(
      error instanceof Error ? error.message : "Unable to remove membership.",
      "error",
    );
  }
}

async function addGuestPrivs(checkoutNow: boolean) {
  const parent = existingCartMembership.value;
  const item = guestPrivsProduct.value;
  if (!memberOrder || !parent || !item || !personRef()) return;
  try {
    const request: AddToCart = {
      itemInstance: { assignId: item.catalogItemInstance.assignId },
      person: personRef(),
      quantity: 1,
      specifiedAmountCents: null,
      parent: { assignId: parent.assignId },
      options: {
        cardNum: null,
        balanceNumber: null,
        membership: null,
        donation: null,
      },
      updateLine: null,
    };
    await memberOrder.add(request);
    if (checkoutNow) await router.push({ name: "portal-cart" });
  } catch (error) {
    notification.addSnackbar(
      error instanceof Error
        ? error.message
        : "Unable to add guest privileges.",
      "error",
    );
  }
}

async function removeGuestPrivs() {
  const line = existingCartGP.value;
  if (!memberOrder || !line) return;
  try {
    await memberOrder.remove({ assignId: line.assignId });
  } catch (error) {
    notification.addSnackbar(
      error instanceof Error
        ? error.message
        : "Unable to remove guest privileges.",
      "error",
    );
  }
}

async function addMembership(checkoutNow: boolean) {
  const item = membershipProduct.value;
  if (!memberOrder || !item) return;
  try {
    if (!memberOrder.orderRef.value) await memberOrder.open();
    if (!personRef())
      throw new Error("A purchaser is required to add a membership.");
    if (!existingCartMembership.value) {
      await memberOrder.add(
        buildMemberCatalogPurchase(item, { recipient: personRef() }),
      );
    }
    if (checkoutNow) await router.push({ name: "portal-cart" });
  } catch (error) {
    notification.addSnackbar(
      error instanceof Error ? error.message : "Unable to add membership.",
      "error",
    );
  }
}

onMounted(async () => {
  const catalog = await useCatalog();
  const typeId = props.membershipType.membershipTypeId;
  if (typeId == null) {
    membershipPrice.value = "FROM TYPE";
    return;
  }
  membershipProduct.value = catalog.getMembershipItem(typeId) ?? null;
  guestPrivsProduct.value = catalog.getGuestPrivsItem() ?? null;
  if (membershipProduct.value)
    membershipPrice.value = membershipProduct.value.price.toString();
});
</script>
